import React from 'react';
import { BeefCutoutChart } from '../components/BeefCutoutChart';
import { BeefCutoutTable } from '../components/BeefCutoutTable';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketIQNav } from '../components/MarketIQNav';
export function MarketIQ() {
  return <MarketIQLayout activeSection="beef" data-id="element-441" data-mp="2e1bx5e7etpzn">
      <BeefCutoutChart data-id="element-442" data-mp="2e0j1b89zokwa" />
      <MarketIQNav current="beef" data-id="element-443" data-mp="2dyzjhd8oq1se" />
      <BeefCutoutTable data-id="element-444" data-mp="2a006r6gpp0qe" />
    </MarketIQLayout>;
}